<template>
  <div>
    <chat-window
      :current-user-id="currentUserId"
      :rooms="[
          {
            roomId: 1,
            roomName: complaintForm.user_name,
            index: 1,
            users: [
              {
                _id: complaintForm.user_code,
                username: complaintForm.user_name
              },
              {
                _id: currentUserId,
                username: 'Admin Isikulkas',
              },
              {
                _id: 12,
                username: 'Dummy',
              }
            ]
          }
        ]"
      :messages="messages"
      :loadingRooms="loadingRooms"
      :messagesLoaded="messagesLoaded"
      :showFiles="showFiles"
      :isLoading="isLoading"
      @open-file="openFile"
      @send-message="sendMessage"
    >
    </chat-window>

    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import Loading from "../../../templates/Loading";
import GlobalTable from "../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";

import ChatWindow from 'vue-advanced-chat'
import 'vue-advanced-chat/dist/vue-advanced-chat.css'

export default {
  name: "Respond_Chat",
  components: { GlobalTable, Loading, ChatWindow },
  data() {
    return {
      title: "Respond Chat",
      activeTab: 0,
      items: [],
      complaintdetail: [],
      complaintStatusList: [],
      complaintForm: tableInterfaces.complaint,
      complaintDetailForm: tableInterfaces.complaint_detail,
      isLoading: false,
      activeTab: 0,
      rooms: [],
      loadingRooms: true,
      messages: [],
      messagesLoaded: false,
      currentUserId: '',
      local_code : localStorage.admin_code,
      local_name : '',
			roomId: 1,
      route: '',
      complaintId:'',
      showFiles:true
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  methods: {
    init: function (id) {
      this.getDetailIssue(id);

      if(localStorage.is_agent === 'false'){
        this.local_name = 'Users'
        this.currentUserId = localStorage.admin_code
      }else{
        this.local_name = 'Admin'
        this.currentUserId = 11
      }
    },
    openFile({ file }) {
			window.open(file.file.url, '_blank')
		},
    resetForm: function () {
      for (var i in tableInterfaces.complaint) {
        tableInterfaces.complaint[i] = null;
      }
      this.complaintForm = tableInterfaces.complaint;
    },
    getDetailIssue: function (id) {
      this.isLoading = true;
      this.resetForm();
      this.axios
        .get("console/complaint/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            // console.log(response.data)
            this.complaintForm = response.data.data;
            this.complaintForm.user_code = response.data.data.user_name;
            this.complaintdetail = response.data.dataDetail;
            this.complaintStatusList = response.data.complaint_status;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getResponse(route){
      this.isLoading = true;

      this.axios
      .get("console/complaint/detail/"+route)
      .then((response) => {
        if (response.data.status === 2000) {
          // console.log(response.data)
          let data_detail = [],
              date_full = new Date(response.data.data.date_inserted),
              data_date = '',
              datemonth= date_full.getMonth()+1,
              dateday= date_full.getDate(),
              datehours= date_full.getHours(),
              dateminutes= date_full.getMinutes(),
              the_code='',
              the_name='',
              data_full ='',
              monthName = ['no','January','Febuary','March','April','May','June','July','August','September','October','November','December'],
              array_dataDetail = response.data.dataDetail;
          
          //set current user name & code
          the_name = response.data.data.user_name
          the_code = response.data.data.user_code

          if(datehours < 10){
            datehours = '0'+date_full.getHours();
          }

          if(dateminutes < 10){
            dateminutes = '0'+date_full.getMinutes();
          }

          if(dateday < 10){
            dateday = '0'+date_full.getDate();
          }

          //set current complaint ID
          this.complaintId=response.data.data.id;
          
          data_full = dateday+' '+monthName[datemonth]+' '+date_full.getFullYear();
          data_date = datehours+':'+dateminutes;

          data_detail.push({
            _id: 1,
            roomId: this.roomId,
            content: response.data.data.complaint_type,
            senderId: response.data.data.user_code,
            username: response.data.data.user_name,
            date: data_full,
            timestamp: data_date,
            seen: true,
            disableActions: true,
            disableReactions: true
          })

          // console.log(data_detail)

          //console.log(response.data.data)              
          let i = 1,
              the_id='',
              username='';

          array_dataDetail.forEach(function(respontambah){
            // console.log(respontambah)
            i++;

            let files_content = '',
                thefile='',
                message=respontambah.messages;

            date_full = new Date(respontambah.response_time);
            datehours = date_full.getHours(),
            dateminutes = date_full.getMinutes(),
            datemonth=date_full.getMonth()+1,
            dateday=date_full.getDate();
            
            if(datehours < 10){
              datehours = '0'+datehours;
            }

            if(dateminutes < 10){
              dateminutes = '0'+dateminutes;
            }

            if(dateday < 10){
              dateday = '0'+dateday;
            }

            //Check user code
            if(respontambah.response_by_agent !== null){
              the_id = 11;
            }else if(respontambah.response_by !== null){
              the_id = respontambah.response_by
            }else{
              the_id = respontambah.response_by_admin
            }

            // console.log(the_id)

            if(respontambah.attachment){
              files_content = [{
                type:'image/png',
                extension: 'png',
                name: 'respond-mini',
                url:'https://storage.googleapis.com/isikulkas/'+respontambah.attachment,
                preview:'https://storage.googleapis.com/isikulkas/'+respontambah.attachment,
                size:2628,
                duration:14.4,
                audio:false
              }]
              
              thefile = 'https://storage.googleapis.com/isikulkas/'+respontambah.attachment;
              message = thefile+' '+respontambah.messages;
            }

            data_full = dateday+' '+monthName[datemonth]+' '+date_full.getFullYear();
            data_date = datehours+':'+dateminutes;

            data_detail.push({
              _id: i,
              roomId: 1,
              content: message,
              senderId: the_id,
              username: respontambah.response_name,
              date: data_full,
              timestamp: data_date,
              seen: true,
              disableActions: true,
              disableReactions: true,
              files:files_content
            })
          })

          this.messages=data_detail;

          // console.log(this.messages)
        } else {
          this.showErrorNotification({
            title: this.title,
            message: response.data.message,
          });
        }
      })
      .catch((error) => {
        this.showErrorNotification({
          title: this.title,
          message: error,
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    getBase64Image(imgUrl,callback){
      var img = new Image();

      // onload fires when the image is fully loadded, and has width and height

      img.onload = function(){

        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");

        callback(dataURL); // the base64 string
      };

      // set attributes and src 
      img.setAttribute('crossOrigin', 'anonymous'); //
      img.src = imgUrl;
    },
    async sendMessage({ content, roomId, file, replyMessage, event, files }) {
      this.isLoading = true;

			const message = {
        id: this.complaintId,
				complaint_type: content
			}

      let local = '',
              x = this;

      // console.log(this.complaintForm)
      // console.log(this.complaintDetailForm)

      // CONVERT MANUAL TO BASE64image
      if(file){
        local = file.localUrl

        // ini buat dapat BLOB:URL
        this.getBase64Image(local, function(base64image){
          x.complaintDetailForm.raw_attachment = base64image;

          x.complaintDetailForm.complaint_id = x.complaintForm.id
          x.complaintDetailForm.messages = content
          x.complaintDetailForm.order_number = x.complaintForm.order_number
          
          x.complaintDetailForm.response_by_agent = x.local_code
          x.complaintDetailForm.response_name = x.local_name

          x.axios
          .post("console/complaint/add-response", x.complaintDetailForm)
          .then((response) => {
            if (response.data.status === 2000) {
              // console.log(response)
              x.showInfoNotification({
                title: x.title,
                message: response.data.message,
              });
            } else {
              x.showErrorNotification({
                title: x.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            x.showErrorNotification({
              title: x.title,
              message: error,
            });
          })
          .finally(() => {
            x.getResponse(x.route)
          });
        });
        // console.log(this.complaintDetailForm.raw_attachment)
      }else{
        this.complaintDetailForm.complaint_id = this.complaintForm.id
        this.complaintDetailForm.messages = content
        this.complaintDetailForm.order_number = this.complaintForm.order_number
        this.complaintDetailForm.response_by_agent = this.local_code
        this.complaintDetailForm.response_name = this.local_name

        this.axios
        .post("console/complaint/add-response", this.complaintDetailForm)
        .then((response) => {
          if (response.data.status === 2000) {
            // console.log(response)
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.getResponse(this.route)
        });
      }

      this.isLoading = false;
      this.complaintDetailForm.raw_attachment = null;
      file = null;
      this.loadingRooms = false
      this.messagesLoaded = true
		},
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);

    this.route = route[4]

    this.getResponse(route[4])

    this.loadingRooms = false
    this.messagesLoaded = true
  },
};
</script>

<style>
/* .vac-box-footer > .vac-icon-textarea > .vac-svg-button:nth-child(2)*/
.vac-rooms-container.vac-app-border-r,
.vac-room-wrapper .vac-svg-button.vac-toggle-button,
.vac-box-footer > .vac-icon-textarea-left,
.vac-box-footer > .vac-icon-textarea > .vac-wrapper{
  display:none;
}
.vac-card-window{
  height:380px !important;
}
</style>